import { createNavigationController } from 'components/NavigationController'

export default createNavigationController()